import { defineMessages } from "react-intl";

import {
	haemostaseologyTypeMessages,
	hasDiseaseMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/haemostaseology";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	haemostaseology: {
		id: "ktx.form.haemostaseology.title",
		defaultMessage: "Thromboembolia"
	},
	diseases: {
		id: "ktx.form.haemostaseology.value",
		defaultMessage: "Anamnézis"
	},
	hasDisease: {
		id: "ktx.form.haemostaseology.hasDisease",
		defaultMessage: "Anamnézis?"
	},
	other: {
		id: "ktx.form.haemostaseology.other",
		defaultMessage: "Egyéb thromboembolia"
	},
	comment: {
		id: "ktx.form.haemostaseology.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasDisease"],
						label: messages.hasDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasDiseaseMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "haemostaseologyType"],
						label: messages.diseases,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: haemostaseologyTypeMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "haemostaseologyTypeOther"],
						label: messages.other,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["comment"],
						label: messages.comment,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_haemostaseology",
	value: {
		schemaId: "haemostaseology",
		title: messages.haemostaseology,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
